import { FC, useMemo } from 'react';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import { NOTIFICATION_DEFAULT_ERROR_MESSAGE, useNotificationContext } from 'application/providers/NotificationProvider';
import Text from '@zvuk-b2b/react-uikit/ui/Text';
import styles from './index.module.scss';

import { TEXTS } from '../../texts';
import { useSelectMasterVideoStreamViewModel } from './useSelectMasterVideoStreamViewModel';
import { ChooseVideoStream } from '../../PointsGroupDrawer/ChooseVideoStreamList';

interface ISelectMasterVideoStreamProps {
  close: () => void;
}

const SelectMasterVideoStream: FC<ISelectMasterVideoStreamProps> = ({ close }) => {
  const {
    isButtonDisabled,
    createPointsGroup,
    isButtonLoading,
    masterVideoStreamId,
    videoStreams,
    setMasterVideoStreamId,
    onBack,
  } = useSelectMasterVideoStreamViewModel({ close });

  const { isIpad } = useMedia();

  const notification = useNotificationContext();

  const handleSaveClick = async () => {
    close();
    try {
      await createPointsGroup();
    } catch (error: any) {
      notification.showErrorNotification({
        children: error?.message ? error.message : NOTIFICATION_DEFAULT_ERROR_MESSAGE,
      });
    }
  };

  const actionButtons = useMemo(
    () => [
      <Button
        key="button_choose_master_video_stream_modal_submit"
        elementId="button_choose_master_video_stream_modal_submit"
        type={ButtonType.PRIMARY}
        isLoading={isButtonLoading}
        onClick={handleSaveClick}
        isDisabled={isButtonDisabled}>
        {TEXTS.MODAL_SELECT_POINTS_BUTTON_SUBMIT_TEXT}
      </Button>,
      <Button
        key="button_choose_master_video_stream_modal_close"
        elementId="button_choose_master_video_stream_modal_close"
        type={ButtonType.SECONDARY}
        onClick={onBack}
        isDisabled={isButtonLoading}>
        {TEXTS.BACK}
      </Button>,
    ],
    [isButtonLoading, isButtonDisabled, handleSaveClick]
  );

  return (
    <ModalScreen
      title={TEXTS.MODAL_SELECT_MASTER_VIDEO_STREAM_TITLE}
      titlePlacement="left"
      disableScroll={!isIpad}
      contentClassName={styles.VideoStreamBindModalContent}
      onClose={close}
      actionButtons={actionButtons}>
      <div className={styles.hint}>
        <Text elementId="choose_master_video_stream_modal_description">
          {TEXTS.MODAL_SELECT_MASTER_VIDEO_STREAM_DESCRIPTION}
        </Text>
      </div>
      <ChooseVideoStream
        masterVideoStreamId={masterVideoStreamId}
        videoStreams={videoStreams}
        setVideoStreamId={setMasterVideoStreamId}
      />
    </ModalScreen>
  );
};

export default SelectMasterVideoStream;
